import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=00d1572e&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=00d1572e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1572e",
  null
  
)

export default component.exports